import { Skeleton } from '@/components/ui/skeleton';

export function LinkCardSkeleton() {
  return (
    <div className="relative px-4 py-5">
      {/* Header: Dot space + Favicon + Title area */}
      <div className="flex items-start gap-3">
        {/* Unread dot space */}
        <div className="w-2 pt-2">
          <Skeleton className="h-2 w-2 rounded-full" />
        </div>

        {/* Favicon */}
        <Skeleton className="h-6 w-6 rounded flex-shrink-0" />

        {/* Title + Metadata */}
        <div className="flex-1 space-y-2">
          <Skeleton className="h-5 w-3/4" />
          <Skeleton className="h-3.5 w-1/2" />
        </div>
      </div>

      {/* Summary - aligned with content (ml-11 = 2 + gap-3 + 24px favicon) */}
      <div className="mt-2 ml-11 space-y-1.5">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-4/5" />
      </div>
      {/* Inset separator */}
      <div className="absolute bottom-0 right-0 left-[36px] h-px bg-border" />
    </div>
  );
}
